import PropTypes from 'prop-types';
import React from 'react';
import { main } from './Layout.module.scss';
import './Layout.scss';
import Footer from './components/global/Footer';
import GlobalAnimations from './components/global/GlobalAnimations';
import Header from './components/global/Header';

const Layout = ({ children, initialBgColor }) => {
  return (
    <>
      <Header />
      <main id="main" tabIndex={-1} className={`${main}`}>
        <GlobalAnimations initialBgColor={initialBgColor}>
          {children}
        </GlobalAnimations>
      </main>
      <Footer />
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
